module.exports = __webpack_public_path__ + "img/sup_withdraw_jeton2.19a0028e.jpg";